<div class="user_profile_container">
  <!-- Loading State -->
  <div v-if="is_loading" class="text-center py-5">
    <div class="spinner-border text-primary-dark spinner-border-sm" role="status"></div>
    <p class="text-xxs mt-2 text-muted">Loading user details...</p>
  </div>

  <!-- Error State -->
  <div v-else-if="error_message" class="alert alert-danger rounded-lg p-4 shadow-sm">
    <div class="d-flex align-items-center gap-3">
      <i class="bi bi-exclamation-circle-fill fs-5"></i>
      <div>
        <p class="text-xs mb-1">{{ error_message }}</p>
        <button @click="fetch_user_details" class="btn btn-sm btn-outline-danger text-xxs rounded-small">
          <i class="bi bi-arrow-clockwise me-1"></i>Retry
        </button>
      </div>
    </div>
  </div>

  <!-- User Details State -->
  <div v-else-if="user_details" class="user_profile_card">
    <!-- Header Section -->
    <div class="border rounded-lg mb-3 p-4 section-bg shadow-sm">
      <div class="d-flex justify-content-start align-items-start gap-3">
        <div class="d-flex gap-3 flex-grow-1">
          <div class="bg-primary-dark d-flex text-white fw-bold">
            {{ get_initials() }}
          </div>
          <div class="flex-grow-1">
            <h5 class="text-sm fw-bold mb-1">{{ user_details.full_name || 'N/A' }}</h5>
            <p class="text-xxs text-muted mb-2">{{ user_details.email || 'No email provided' }}</p>
            <div class="d-flex gap-2">
              <span :class="['status-badge', 'text-xxs', 'px-2', 'py-1', 'rounded-small', get_status_class(user_details.is_active, user_details.is_blocked)]">
                {{ user_details.is_blocked ? 'Blocked' : user_details.is_active ? 'Active' : 'Inactive' }}
              </span>
            </div>
          </div>
        </div>
        <button v-if="!is_editing" @click="start_editing" class="d-none btn btn-link text-primary-dark p-0" title="Edit profile">
          <i class="bi bi-pencil-square fs-5"></i>
        </button>
        <div v-else class="d-flex gap-2">
          <button @click="cancel_editing" class="btn btn-sm btn-outline-secondary text-xxs rounded-small">Cancel</button>
          <button @click="save_changes" class="btn btn-sm btn-primary-dark text-xxs rounded-small">Save</button>
        </div>
      </div>
    </div>

    <!-- Personal Information Section -->
    <div class="border rounded-lg mb-3 p-4 section-bg shadow-sm">
      <h6 class="text-xs fw-bold mb-3 text-capitalize d-flex align-items-center gap-2">
        <i class="bi bi-person-fill"></i>Personal Information
      </h6>
      <div class="row g-3">
        <div class="col-md-6">
          <div class="form-group">
            <label class="text-xxs fw-bold text-muted mb-2">First Name</label>
            <input
              type="text"
              class="form-control form-control-sm text-xxs bg-white border py-2 rounded-lg"
              v-model="edited_details.first_name"
              :disabled="!is_editing"
              placeholder="First name not provided"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="text-xxs fw-bold text-muted mb-2">Last Name</label>
            <input
              type="text"
              class="form-control form-control-sm text-xxs bg-white border py-2 rounded-lg"
              v-model="edited_details.last_name"
              :disabled="!is_editing"
              placeholder="Last name not provided"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="text-xxs fw-bold text-muted mb-2">Email Address</label>
            <input
              type="email"
              class="form-control form-control-sm text-xxs bg-white border py-2 rounded-lg"
              v-model="edited_details.email"
              :disabled="!is_editing"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="text-xxs fw-bold text-muted mb-2">Phone Number</label>
            <input
              type="email"
              class="form-control form-control-sm text-xxs bg-white border py-2 rounded-lg"
              v-model="edited_details.phone_number"
              :disabled="!is_editing"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div v-else class="alert alert-info rounded-lg p-4 shadow-sm">
    <p class="mb-0 text-xs text-muted">No user details available</p>
  </div>
</div>